import React from "react";
import {connect} from "react-redux";
import {Select} from "evergreen-ui";
import {getCommonCourts} from "../util";


const CourtSelector = (props) => {

    const {
        cart,
        selectedCourt,
        updateSelectedCourt,
    } = props;

    const courts = (cart && cart.slots && cart.slots.length && getCommonCourts(cart.slots)) || [];

    if (courts.length && !selectedCourt.courtId) {
        updateSelectedCourt(courts[0].courtId, courts)
    }

    return (
        <Select
            height={40}
            value={selectedCourt.courtId || (courts.length && courts[0])}
            onChange={(e) => updateSelectedCourt(e.target.value, courts)}
        >
            {courts ? courts.map((court, index) => {
                return (
                    <option
                        key={index}
                        value={court.courtId}
                    >
                        {court.courtName}
                    </option>
                )
            }) : <React.Fragment/>}
        </Select>
    )
};

const mapStateToProps = (
    {
        cart,
    }) => ({
        cart,
    }
);

export default connect(mapStateToProps)(CourtSelector);
